import { t } from '@/features/i18n/utils';
import { ProcurementBreadcrumbs } from '@/features/subcontractor-bids/components/procurement-breadcrumbs';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { H1 } from '@/ui/components/heading';
import {
  MainContainer,
  MainHeader,
  MainHeaderBackButton,
  MainScrollArea,
} from '@/ui/components/main';
import { Sidenav, SidenavItem, SidenavLink, SidenavList } from '@/ui/components/sidenav';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId, workspaceId, procurementId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton from={Route.fullPath} />
        <ProcurementBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Settings', nb: 'Innstillinger' })}</BreadcrumbPage>
        </ProcurementBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <MainHeader className="max-md:hidden">
          <H1>
            <MainHeaderBackButton from={Route.fullPath} />
            {t({ en: 'Settings', nb: 'Innstillinger' })}
          </H1>
        </MainHeader>
        <div className="flex flex-col @3xl:flex-row">
          <Sidenav className="@3xl:sticky top-0 h-fit">
            <SidenavList className="p-4">
              <SidenavItem>
                <SidenavLink
                  to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings"
                  params={{ projectId, workspaceId, procurementId }}
                  activeOptions={{ exact: true }}
                >
                  {t({ en: 'General', nb: 'Generelt' })}
                </SidenavLink>
              </SidenavItem>
              <SidenavItem>
                <SidenavLink
                  to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines"
                  params={{ projectId, workspaceId, procurementId }}
                >
                  {t({ en: 'Disciplines', nb: 'Fagområder' })}
                </SidenavLink>
              </SidenavItem>
            </SidenavList>
          </Sidenav>
          <MainContainer>
            <Outlet />
          </MainContainer>
        </div>
      </MainScrollArea>
    </>
  );
}
